<template>
  <div class="main">
    <div class="chat__wrap">
      <!-- <div class="chat-header__container">
        <div class="back-icon" @click="$router.push('qnaManage')">
              <img src="~img/btn/btn_back2.png" alt="" />
            </div>
        <div class="name__contents">
          <div class="profile">
            <img :src="`${titleProfileUrl}?w=100&f=webp&q=75`" class="profile-image" alt="" v-if="titleProfileUrl" />
            <img src="~/img/group/cus_manage_tery.svg" class="profile-image" v-else />
          </div>
          <div class="name">{{ $store.state.chatRoomInfo.name }}</div>
        </div>
      </div> -->
      <div class="section scroll"
           ref="sectionScroll">
        <div class="chat-contents__wrap"
             v-for="(item, index) in chatContents"
             :key="index">
          <div class="holding-display-date__container"
               v-if="item.holdingDisplayDate">
            <div class="holding-display-date__contents">
              {{ item.holdingDisplayDate }}
            </div>
          </div>
          <div :class="[
              'chat-contents chat-contents--answerer',
              {
                store: item.type === 'live_answerer',
                customer: item.type === 'live_questioner',
                order: item.type === 'live_order',
              },
            ]"
               v-if="item.userSeq !== myUserSeq">
            <div class="user-info__contents"
                 v-if="item.type === 'live_order'">
              <img src="@/assets/icon/order_profile.png"
                   class="profile-image"
                   alt="" />
            </div>
            <div class="user-info__contents"
                 v-else>
              <img :src="imageCheck(item.userProfile)"
                   class="profile-image"
                   alt=""
                   v-if="!$empty(item.userProfile)"
                   @click="moveToHome(item)" />
              <img src="@/assets/icon/customer_profile.png"
                   class="profile-image"
                   alt=""
                   v-else />
            </div>
            <div class="inner__contents">
              <!-- <div class="name">{{ item.name }}</div> -->
              <div class="inner__image"
                   v-if="!$empty(item.contents) && item.contents !== '' && item.contents.substring(0, 37) === 'https://d2nic58uh63efu.cloudfront.net'">
                <div class="name"
                     v-if="item.type !== 'live_order'">{{ item.name }}</div>
                <img class="inner__image__src"
                     :src="item.contents" />
              </div>
              <div class="inner__text"
                   v-else-if="item.userSeq === 'store'"
                   v-html="item.contents">
                <div class="name"
                     v-if="item.type !== 'live_order'">{{ item.name }}</div>
              </div>
              <div class="inner__text"
                   v-else>
                <div class="name"
                     v-if="item.type !== 'live_order'">{{ item.name }}</div>
                {{ item.contents }}
              </div>
              <div class="time">{{ item.datetime | dateformat }}</div>
            </div>
          </div>
          <div class="chat-contents chat-contents--questioner"
               v-else>
            <div class="inner__contents">
              <div class="inner__image"
                   v-if="!$empty(item.contents) && item.contents !== '' && item.contents.substring(0, 37) === 'https://d2nic58uh63efu.cloudfront.net'">
                <div class="name"
                     v-if="item.type !== 'live_order'">{{ item.name }}</div>
                <img class="inner__image__src"
                     :src="item.contents" />
              </div>
              <div class="inner__text"
                   v-else>
                <div class="name">{{ item.name }}</div>
                {{ item.contents }}
              </div>
              <div class="time">{{ item.datetime | dateformat }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal name="phoneNumberModal"
           :width="'95%'"
           :clickToClose="false">
      <div class="phoneNumberMain">
        <span class="closeBtn"
              @click="[inputCancel(), $modal.hide('phoneNumberModal')]">×</span>
        <h2 class="phoneNumberTitle">
          대화명을 입력해주세요.
        </h2>
        <div class="addr-div-top">
          <div class="addr-div1"
               style="display: none;">
            <div class="addr-div-title">
              전화번호
            </div>
            <div class="addr-div-content">
              <input type="number"
                     class="addr-div-input"
                     ref="phoneInput"
                     placeholder="'-' 없이 숫자만 입력하세요."
                     v-model="$store.state.customerPhone">
            </div>
          </div>
          <div class="addr-div1">
            <div class="addr-div-title">
              이름/닉네임
            </div>
            <div class="addr-div-content">
              <input type="text"
                     class="addr-div-input"
                     ref="nameInput"
                     name="nameInput"
                     id="nameInput"
                     placeholder="이름 또는 닉네임을 입력해주세요."
                     v-model="$store.state.customerName">
            </div>
          </div>
        </div>
        <div class="phoneNumberFoot">
          <button class="cancelBtn"
                  style="display: none;"
                  @click="[inputCancel(), $modal.hide('phoneNumberModal')]">취소</button>
          <button class="confirmBtn"
                  @click="[searchCustomer(), $modal.hide('phoneNumberModal')]">확인</button>
        </div>
      </div>
    </modal>
    <modal name="smsDenied"
           :width="'99%'"
           :height="350"
           :clickToClose="false">
      <div class="certifyMain"
           style="position:relative;border: 1px solid rgba(234, 78, 131, 0.5);">
        <span class="closeBtn"
              @click="$modal.hide('smsDenied')">×</span>
        <div class="certifyHead">
          <h3>{{$store.state.storeInfo.STORE_NAME}} 수신거부</h3>
          <hr style="color:#e0e0e0;">
        </div>
        <div class="certifyBody">
          <div class="certifyBody-inner"
               style="justify-content: center">
            <span>수신거부를 하시면<br>더 이상 행사정보를 받을 수 없습니다.</span>
          </div>
          <div class="certifyBody-inner">
            <span style="width: 30%">전화번호: </span>
            <input type="tel"
                   name="phone"
                   id="phone"
                   v-model="$store.state.userPhone"
                   class="certify-phone-input"
                   style="width: 70%"
                   placeholder="휴대전화번호"
                   v-if="chkConfirm !== 1">
            <input type="tel"
                   name="phone"
                   id="phone"
                   v-model="$store.state.userPhone"
                   class="certify-phone-input-readonly"
                   style="width: 70%"
                   placeholder="휴대전화번호"
                   readonly
                   v-if="chkConfirm === 1">
          </div>
          <div class="certifyBody-inner"
               style="justify-content: flex-end">
            <button class="certify-phone-btn"
                    @click="getConfirmNo"
                   style="background: #EA4E83; color: #FFFFFF"
                    v-if="chkConfirm === 0 && $empty($store.state.userPhone) && $store.state.userPhone.length > 0">인증번호받기</button>
            <button class="certify-phone-btn-readonly"
                    v-if="chkConfirm === 1">인증번호받기</button>
          </div>
          <div class="certifyBody-inner"></div>
          <div class="certifyBody-inner"
               style="justify-content: space-between;"
               v-if="chkConfirm === 1">
            <span style="width: 30%">인증번호: </span>
            <input type="number"
                   v-model="confirmNumber"
                   class="certify-phone-input"
                   style="width: 70%"
                   placeholder="인증번호 입력">
          </div>
        </div>
        <div class="certifyFoot-on"
            @click="chkConfirmNo"
            v-if="chkConfirm === 1 && $empty($store.state.userPhone) && confirmNumber.length > 0">
          <span>확인</span>
        </div>
      </div>
    </modal>
    <div style="width: 100%; height: 170px; background: #f7f7f7;"></div>
    <div class="info-button">
      <div class="button-image">
        <img src="@/assets/btn_chat_info.png"
             @click="inputInfo()"
             style="width: 100%;" />
      </div>
      <div class="button-image">
        <a :href="'tel:' + $store.state.storeInfo.STORE_TEL"
           @click="callStore()">
          <img src="@/assets/btn_chat_call.png"
               style="width: 100%;" />
        </a>
      </div>
      <div class="button-image">
        <img src="@/assets/btn_sms_denied.png"
             @click="smsDenied()"
             style="width: 100%;" />
      </div>
    </div>
    <AppChatBar :myUserSeq="myUserSeq"
                :myUserName="myUserName"
                @handleAddData="addData" />
  </div>
</template>
<script>
import * as queries from '@/graphql/queries'
import * as mutation from '@/graphql/mutations'
import * as subscribe from '@/graphql/subscriptions'
import { API, graphqlOperation } from 'aws-amplify'
import dayjs from 'dayjs'
import AppChatBar from '@/components/chat/AppChatBar.vue'
export default {
  name: 'chat',
  components: {
    AppChatBar
  },
  filters: {
    dateformat: (value) => {
      if (dayjs(value).format('HH:mm A').indexOf('오전') > -1 || dayjs(value).format('HH:mm A').indexOf('AM') > -1) {
        return `오전 ${dayjs(value).format('h:mm')}`
      } else {
        return `오후 ${dayjs(value).format('h:mm')}`
      }
    }
  },
  metaInfo () {
    return {
      title: `채팅 | 스마트전단 - ${this.$store.state.storeInfo.STORE_NAME}`
    }
  },
  data () {
    return {
      chatContents: [],
      preDatetime: null,
      titleProfileUrl: '',
      textarea: '',
      // storeName: null,
      // storeLogo: null,
      myUserSeq: '',
      myUserName: '',
      scrollY: 0,
      chkConfirm: 0,
      confirmNumber: ''
    }
  },
  computed: {
    storeName () {
      return this.$store.state.storeInfo.STORE_NAME
    },
    storeLogo () {
      return this.$store.state.storeInfo.STORE_LOGO
    }
  },
  // textareaStatus: function () {
  //   if (this.textarea.replace(/\s|/gi, '').length > 0) {
  //     return true
  //   }
  //   return false
  // },
  async created () {
    console.log('created :::::', this.$options.name)
    const vm = this
    if (!vm.$empty(vm.$cookies.get('userSeq'))) {
      vm.myUserSeq = vm.$cookies.get('userSeq')
    }
    if (!vm.$empty(vm.$cookies.get('userName'))) {
      vm.myUserName = vm.$cookies.get('userName')
    }
    vm.$store.commit('setTitle', '스마트전단채팅')
  },
  async mounted () {
    console.log('mounted :::::', this.$options.name)
    const vm = this
    // vm.storeName = storeInfo.STORE_NAME
    // console.log('logo :::::', storeInfo.STORE_LOGO)
    // const storeLogoArray = storeInfo.STORE_LOGO.split('/')
    // const storeLogoUrl = storeLogoArray[1].replace(',', '/')
    // vm.storeLogo = `https://d2nic58uh63efu.cloudfront.net/${storeLogoUrl}`
    // vm.storeLogo = storeInfo.STORE_LOGO
    vm.$store.state.storeSeq = vm.$_.cloneDeep(vm.$route.query.seq)
    window.addEventListener('beforeunload', vm.unLoadEvent)
    vm.updateNumberParticipants('in')
    vm.inputCancel()
    await vm.roomCheck()
    await vm.getChatInfo()
    vm.subscribe()
    vm.setScrollPosition()
  },
  methods: {
    async createFirstChatInfo () {
      const vm = this
      const data = {
        storeSeq: vm.$route.query.seq,
        sK: `CHAT#LIVE#${vm.$dayjs().format('YYYYMMDDHHmmss')}`,
        datetime: vm.$dayjs().format('YYYY-MM-DD HH:mm:ss'),
        contents: '라이브 채팅방에 오신 걸 환영 합니다.',
        name: vm.storeName,
        type: 'live_answerer',
        roomType: 'live'
      }
      await API.graphql({
        query: mutation.createStoreQnaInfoTable,
        variables: { input: data }
      })
    },
    updateNumberParticipants (mode) {
      const vm = this
      let count = 1
      if (mode === 'out') {
        count = -1
      }
      const data = {
        storeSeq: vm.$route.query.seq,
        sK: 'ROOM#LIVE',
        numberParticipants: count
      }
      API.graphql({
        query: mutation.updateNumberParticipants,
        variables: { input: data }
      })
    },
    setScrollPosition () {
      const element = document.querySelector('html')
      element.scrollTop = element.scrollHeight
    },
    async addData (obj) {
      console.log('addData :::::', obj)
      const vm = this
      const date = vm.$dayjs(obj.data.datetime).locale('ko').format('YYYY.MM.DD (ddd)')

      let holdingDisplayDate = ''
      if (vm.preDatetime !== date) {
        holdingDisplayDate = date
      }
      vm.preDatetime = date
      obj.data.holdingDisplayDate = holdingDisplayDate
      vm.chatContents.push(obj.data)
      await vm.$nextTick()
      vm.setScrollPosition()
    },
    unLoadEvent (event) {
      this.updateNumberParticipants('out')
    },
    async roomCheck () {
      const vm = this
      const roomCheck = await API.graphql(
        graphqlOperation(queries.queryStoreQnaInfoTable, {
          storeSeq: vm.$store.state.storeSeq,
          sK: 'ROOM#LIVE'
        })
      )

      if (vm.$empty(roomCheck.data.queryStoreQnaInfoTable.items) || roomCheck.data.queryStoreQnaInfoTable.items.length === 0) {
        // 채팅방 개설
        await API.graphql(
          graphqlOperation(mutation.createStoreQnaInfoTable, {
            input: {
              storeSeq: vm.$store.state.storeSeq,
              sK: 'ROOM#LIVE',
              contents: '',
              datetime: vm.$dayjs().format('YYYY-MM-DD HH:mm:ss'),
              name: '스마트전단 라이브 채팅방',
              type: 'live_room'
            }
          })
        )
      }
    },
    async getChatInfo () {
      const vm = this
      const chatList = await API.graphql(
        graphqlOperation(queries.queryStoreQnaInfoTable, {
          storeSeq: vm.$store.state.storeSeq,
          sK: 'CHAT#LIVE#'
        })
      )
      vm.$_.reverse(chatList.data.queryStoreQnaInfoTable.items)
      if (!vm.$empty(chatList.data.queryStoreQnaInfoTable.items) && chatList.data.queryStoreQnaInfoTable.items.length < 1) vm.createFirstChatInfo()

      // const storeLogoArray = vm.storeLogo.split('/')
      // const storeLogoUrl = storeLogoArray[1].replace(',', '/')
      // vm.storeLogo = `https://d2nic58uh63efu.cloudfront.net/${storeLogoUrl}`

      vm.chatContents = chatList.data.queryStoreQnaInfoTable.items.map((x, index) => {
        const date = vm.$dayjs(x.datetime).locale('ko').format('YYYY.MM.DD (ddd)')

        let holdingDisplayDate = ''
        if (vm.preDatetime !== date) {
          holdingDisplayDate = date
        }
        vm.preDatetime = date

        if (x.type === 'live_answerer') {
          x.userProfile = vm.storeLogo
          x.userSeq = 'store'
        }

        return {
          contents: x.contents,
          datetime: x.datetime,
          isRead: x.isRead,
          name: x.name,
          sK: x.sK,
          storeSeq: x.storeSeq,
          type: x.type,
          userSeq: x.userSeq,
          holdingDisplayDate: holdingDisplayDate,
          userProfile: vm.$empty(x.userProfile) ? '' : x.userProfile
        }
      })
    },
    imageCheck (imageUrl) {
      if (imageUrl.indexOf('cloudfront.net') > -1) {
        return imageUrl + '?w=100&f=webp&q=75'
      } else {
        return imageUrl
      }
    },
    subscribe () {
      const vm = this
      vm.subscription = API.graphql({
        query: subscribe.onCreateStoreQnaInfoTable2,
        variables: {
          storeSeq: vm.$store.state.storeSeq,
          roomType: 'live'
        }
      }).subscribe({
        next: async (response) => {
          console.log('subscribe header :::::', response)
          if (!vm.$empty(response.value.data.onCreateStoreQnaInfoTable2)) {
            if (response.value.data.onCreateStoreQnaInfoTable2.userSeq === vm.myUserSeq) {
              if (!this.$empty(this.chatContents)) {
                const index = this.chatContents.findIndex((chat) => chat.sK === response.value.data.onCreateStoreQnaInfoTable2.sK)
                if (index === -1) {
                  // console.log('sK :::::', response.value.data.onCreateStoreQnaInfoTable2.sK, vm.chatContents[vm.chatContents.length - 1].sK)
                  const sendData = {
                    data: response.value.data.onCreateStoreQnaInfoTable2
                  }
                  vm.addData(sendData)
                }
              }
            } else {
              const date = vm.$dayjs(response.value.data.onCreateStoreQnaInfoTable2.datetime).locale('ko').format('YYYY.MM.DD ddd요일')

              vm.preDatetime = date
              if (response.value.data.onCreateStoreQnaInfoTable2.type === 'live_answerer') {
                response.value.data.onCreateStoreQnaInfoTable2.userProfile = vm.storeLogo
              }
              let holdingDisplayDate = ''
              if (vm.preDatetime !== date) {
                holdingDisplayDate = date
              }
              response.value.data.onCreateStoreQnaInfoTable2.holdingDisplayDate = holdingDisplayDate
              vm.chatContents.push(response.value.data.onCreateStoreQnaInfoTable2)

              await vm.$nextTick()

              vm.setScrollPosition()
            }
          }
        }
      })
    },
    moveToHome (item) {
      console.log('moveToHome :::::', item)
      if (item.userSeq === 'store') {
        this.moveRouter('storeMain')
      }
    },
    async searchCustomer () {
      const vm = this
      if (!vm.$empty(vm.$store.state.customerPhone) && vm.$store.state.customerPhone.length === 11 && !vm.$empty(vm.$store.state.customerName)) {
        vm.$axios({
          method: 'post',
          url: `${process.env.API}/chkDuplicateNum/${vm.$route.query.seq}/${vm.$store.state.customerPhone}`,
          data: {
            name: vm.$store.state.customerName
          }
        }).then((response) => {
          if (response.data !== 'empty') {
            console.log('customer :::::', response.data)
            vm.myUserSeq = String(response.data.userSeq)
            vm.$cookies.set('userSeq', vm.myUserSeq)
            vm.myUserName = response.data.userName
            vm.$store.state.customerName = vm.myUserName
            vm.$cookies.set('userName', vm.myUserName)
          }
        })
      } else if (!vm.$empty(vm.$store.state.customerPhone) && vm.$store.state.customerPhone.length === 11) {
        vm.$axios({
          method: 'post',
          url: `${process.env.API}/chkDuplicateNum/${vm.$route.query.seq}/${vm.$store.state.customerPhone}`,
          data: {
            name: vm.$store.state.customerPhone.substr(-4)
          }
        }).then((response) => {
          if (response.data !== 'empty') {
            console.log('customer :::::', response.data)
            vm.myUserSeq = String(response.data.userSeq)
            vm.$cookies.set('userSeq', vm.myUserSeq)
            vm.myUserName = response.data.userName
            vm.$store.state.customerName = vm.myUserName
            vm.$cookies.set('userName', vm.myUserName)
          }
        })
      } else if (!vm.$empty(vm.$store.state.customerName)) {
        await vm.setMyUserSeq()
        vm.myUserSeq = localStorage.getItem(`${vm.$route.query.seq}_userSeq`)
        vm.myUserName = vm.$store.state.customerName
        vm.$cookies.set('userName', vm.$store.state.customerName)
      } else {
        vm.inputCancel()
      }
    },
    async inputCancel () {
      const vm = this
      if (vm.$empty(vm.$store.state.customerPhone) && !vm.$empty(vm.myUserSeq)) {
        const userPhone = await vm.$axios.get(`${process.env.API}/userInfo/${vm.myUserSeq}`)
        if (!vm.$empty(userPhone.data) && !vm.$empty(userPhone.data.user_phone)) {
          console.log('getUserInfo :::::', userPhone.data)
          vm.$store.state.customerPhone = userPhone.data.user_phone
          if (!vm.$empty(userPhone.data.user_name)) {
            vm.myUserName = userPhone.data.user_name
          } else if (!vm.$empty(userPhone.data.user_phone)) {
            vm.myUserName = userPhone.data.user_phone.substring(userPhone.data.user_phone.length - 4)
          }
          vm.$store.state.customerName = vm.myUserName
          vm.$cookies.set('userName', vm.myUserName)
        }
      }
      if (vm.$empty(vm.$store.state.customerName)) {
        await vm.setMyUserSeq()
        vm.myUserSeq = localStorage.getItem(`${vm.$route.query.seq}_userSeq`)
        const flowerName = await vm.$axios.get(`${process.env.API}/getFlowerName/${localStorage.getItem(`${vm.$route.query.seq}_userIndex`)}`)
        // console.log('getFlowerName :::::', flowerName.data)
        vm.myUserName = `${flowerName.data.flowerName}`
        vm.$store.state.customerName = vm.myUserName
        vm.$cookies.set('userName', vm.myUserName)
      }
    },
    async inputInfo () {
      console.log('inputInfo :::::')
      this.$gtag.event('테리문자_라이브채팅_매장정보보기', {
        event_category: this.$route.query.seq,
        event_label: '테리문자_라이브채팅_매장정보보기',
        value: this.$cookies.get('userSeq')
      })
      const vm = this
      const storeInfo = vm.$store.state.storeInfo
      const data = {
        storeSeq: vm.$route.query.seq,
        sK: `CHAT#LIVE#${vm.$dayjs().format('YYYYMMDDHHmmss')}`,
        datetime: vm.$dayjs().format('YYYY-MM-DD HH:mm:ss'),
        contents: `== 매장전화 ==\n${storeInfo.STORE_TEL}\n\n`,
        name: vm.storeName,
        type: 'live_answerer',
        roomType: 'live',
        userProfile: vm.storeLogo,
        userSeq: 'store'
      }
      if (!vm.$empty(storeInfo.storeHourInfo) && Number(storeInfo.storeHourInfo.type) === 0) {
        data.contents += `== 영업시간 ==\n`
        if (storeInfo.storeHourInfo.body[0].startDate === storeInfo.storeHourInfo.body[0].endDate) {
          data.contents += `24시간\n`
        } else {
          data.contents += `${storeInfo.storeHourInfo.body[0].startDate.substr(0, 2)}:${storeInfo.storeHourInfo.body[0].startDate.substr(2)}`
          data.contents += ' ~ '
          data.contents += `${storeInfo.storeHourInfo.body[0].endDate.substr(0, 2)}:${storeInfo.storeHourInfo.body[0].endDate.substr(2)}\n`
        }
        data.contents += `\n`
      } else if (!vm.$empty(storeInfo.storeHourInfo) && Number(storeInfo.storeHourInfo.type) === 1) {
        data.contents += `== 영업시간 ==\n`
        if (!vm.$empty(storeInfo.storeHourInfo.body[0].dayOfWeek) && storeInfo.storeHourInfo.body[0].dayOfWeek.length === 5) {
          data.contents += `주중 : ${storeInfo.storeHourInfo.body[0].startDate.substr(0, 2)}:${storeInfo.storeHourInfo.body[0].startDate.substr(2)}`
          data.contents += ' ~ '
          data.contents += `${storeInfo.storeHourInfo.body[0].endDate.substr(0, 2)}:${storeInfo.storeHourInfo.body[0].endDate.substr(2)}\n`
          data.contents += `주말 : ${storeInfo.storeHourInfo.body[1].startDate.substr(0, 2)}:${storeInfo.storeHourInfo.body[1].startDate.substr(2)}`
          data.contents += ' ~ '
          data.contents += `${storeInfo.storeHourInfo.body[1].endDate.substr(0, 2)}:${storeInfo.storeHourInfo.body[1].endDate.substr(2)}\n`
        } else {
          data.contents += `주중 : ${storeInfo.storeHourInfo.body[1].startDate.substr(0, 2)}:${storeInfo.storeHourInfo.body[1].startDate.substr(2)}`
          data.contents += ' ~ '
          data.contents += `${storeInfo.storeHourInfo.body[1].endDate.substr(0, 2)}:${storeInfo.storeHourInfo.body[1].endDate.substr(2)}\n`
          data.contents += `주말 : ${storeInfo.storeHourInfo.body[0].startDate.substr(0, 2)}:${storeInfo.storeHourInfo.body[0].startDate.substr(2)}`
          data.contents += ' ~ '
          data.contents += `${storeInfo.storeHourInfo.body[0].endDate.substr(0, 2)}:${storeInfo.storeHourInfo.body[0].endDate.substr(2)}\n`
        }
        data.contents += `\n`
      } else if (!vm.$empty(storeInfo.storeHourInfo) && !vm.$empty(storeInfo.storeHourInfo.body) && Number(storeInfo.storeHourInfo.type) === 2) {
        data.contents += `== 영업시간 ==\n`
        for (let i = 0; i < storeInfo.storeHourInfo.body.length; i++) {
          const day = storeInfo.storeHourInfo.body[i]
          if (!vm.$empty(day.dayOfWeek)) {
            for (let l = 0; l < day.dayOfWeek.length; l++) {
              data.contents += `${day.dayOfWeek[l]}`
              if (l + 1 < day.dayOfWeek.length) {
                data.contents += ', '
              }
            }
          }
          data.contents += ' : '
          data.contents += `${storeInfo.storeHourInfo.body[i].startDate.substr(0, 2)}:${storeInfo.storeHourInfo.body[i].startDate.substr(2)}`
          data.contents += ' ~ '
          data.contents += `${storeInfo.storeHourInfo.body[i].endDate.substr(0, 2)}:${storeInfo.storeHourInfo.body[i].endDate.substr(2)}\n`
        }
        data.contents += `\n`
      }
      if (!vm.$empty(storeInfo.DAY_OFF)) {
        data.contents += `== 휴무일 ==\n`
        data.contents += `${storeInfo.DAY_OFF}\n\n`
      }
      if (!vm.$empty(storeInfo.DELIVERY_FLAG) && Number(storeInfo.DELIVERY_FLAG) === 1) {
        data.contents += `== 배달정보 ==\n배달가능 ( `
        const storeDeliveryInfo = vm.$store.state.storeDeliveryInfo
        let startTime = vm.$empty(storeDeliveryInfo.DELIVERY_START_TIME) ? '0000' : storeDeliveryInfo.DELIVERY_START_TIME
        let endTime = vm.$empty(storeDeliveryInfo.DELIVERY_END_TIME) ? '0000' : storeDeliveryInfo.DELIVERY_END_TIME
        if (startTime === endTime) {
          data.contents += `24시간 배달 )\n`
        } else {
          data.contents += `${startTime.substring(0, 2)}:${startTime.substring(2, 4)} ~ ${endTime.substring(0, 2)}:${endTime.substring(2, 4)} )\n`
        }
        if (!vm.$empty(storeDeliveryInfo.MIN_PROMO_COST) && Number(storeDeliveryInfo.MIN_PROMO_COST) > 0) {
          data.contents += `최소배달금액 : ${storeDeliveryInfo.MIN_PROMO_COST}\n`
        }
        if (!vm.$empty(storeDeliveryInfo.DELIVERY_COST) && Number(storeDeliveryInfo.DELIVERY_COST) > 0) {
          data.contents += `기본배달료 : ${storeDeliveryInfo.DELIVERY_COST}\n`
        }
        for (let i = 0; i < storeDeliveryInfo.result.list.length; i++) {
          data.contents += `${vm.numberWithCommas(storeDeliveryInfo.result.list[i].minAmount)} 이상일때 배달료 ${vm.numberWithCommas(storeDeliveryInfo.result.list[i].charge)}\n`
        }
        data.contents += `\n`
        data.contents += `== 주문방법 ==\n`
        data.contents += `상품 우측 하단에 있는 장바구니 아이콘을\n눌러서 주문 가능합니다.\n\n`
      } else {
        data.contents += `== 배달정보 ==\n`
        data.contents += `매장전용\n\n`
      }
      const resultList = await vm.$axios.get(`https://sery.co.kr/store/v2/${vm.$route.query.seq}/batch?startPuter=0&endPuter=30`)
      const nowDate = vm.$dayjs().format('YYYYMMDD')
      if (!vm.$empty(resultList) && resultList.data.count > 0) {
        data.contents += `== 현재 진행 중인 행사 ==\n`
        for (let list of resultList.data.listResult) {
          if (vm.$dayjs(list.startDate).format('YYYYMMDD') <= nowDate && nowDate <= vm.$dayjs(list.endDate).format('YYYYMMDD')) {
            data.contents += `행사명 : ${list.title}\n`
            data.contents += `행사일 : ${vm.$dayjs(list.startDate).format('YYYY.MM.DD')} ~ ${vm.$dayjs(list.endDate).format('YYYY.MM.DD')}\n`
          }
        }
      }
      await API.graphql({
        query: mutation.createStoreQnaInfoTable,
        variables: { input: data }
      })
      const data2 = {
        storeSeq: vm.$route.query.seq,
        sK: 'ROOM#LIVE',
        datetime: vm.$dayjs().format('YYYY-MM-DD HH:mm:ss'),
        contents: '매장정보 알림'
      }
      await API.graphql({
        query: mutation.updateStoreQnaInfoTable,
        variables: { input: data2 }
      })
      // vm.chatContents.push(data)
      await vm.$nextTick()
      vm.setScrollPosition()
    },
    callStore () {
      this.$gtag.event('테리문자_라이브채팅_매장전화걸기', {
        event_category: this.$route.query.seq,
        event_label: '테리문자_라이브채팅_매장전화걸기',
        value: this.$cookies.get('userSeq')
      })
    },
    numberWithCommas (x) {
      if (!x) {
        return '0원'
      } else if (x === 0 || x === '0') {
        return '0원'
      } else {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '원'
      }
    },
    smsDenied () {
      const vm = this
      vm.$gtag.event('수신거부_클릭', {
        event_category: vm.$route.query.seq,
        event_label: vm.$dayjs().format('YYYY-MM-DD HH:mm:ss'),
        value: vm.$cookies.get('userSeq')
      })
      vm.$modal.show('smsDenied')
    },
    getConfirmNo () {
      var regExp = /^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/
      if (!regExp.test(this.$store.state.userPhone)) {
        alert('전화번호를 확인해 주세요.')
      } else {
        // var userPhone = this.$store.state.userPhone
        // userPhone = JSON.stringify(userPhone)
        this.$axios({
          method: 'post',
          url: `https://sery.co.kr/insertConfirmNo`,
          data: {
            userPhone: this.$store.state.userPhone
          }
        }).then((response) => {
          if (response.data.result === 'success') {
            this.chkConfirm = 1
            alert('발급된 숫자 5자리를 입력해 주세요.\n발급까지 (2~3분 정도 걸릴수 있습니다.)')
          }
        })
      }
    },
    chkConfirmNo () {
      if (this.$empty(this.confirmNumber) || this.confirmNumber.length < 5) {
        alert('인증번호를 다시 입력해 주세요')
      } else {
        this.$axios({
          method: 'post',
          url: `https://sery.co.kr/phoneConfirmNo`,
          data: {
            userPhone: this.$store.state.userPhone,
            confirmNo: this.confirmNumber
          }
        }).then((response) => {
          if (response.data.result === 'success') {
            this.denied()
          } else {
            alert('인증번호를 확인해 주세요.')
          }
        })
      }
    },
    denied () {
      this.$axios({
        method: 'get',
        headers: {
          'apikey': 'sery.co.kr'
        },
        url: `https://sery.co.kr/deniedSms?storeSeq=${this.$route.query.seq}&userPhone=${this.$store.state.userPhone}`
      }).then((response) => {
        if (response.data.result === 'success') {
          this.$modal.hide('smsDenied')
        } else {
          alert('인증번호를 확인해 주세요.')
        }
      })
    }
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.unLoadEvent)
    this.subscription.unsubscribe()
    this.updateNumberParticipants('out')
    this.$store.commit('setTitle', '')
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      console.log('beforeRouteEnter :::::', vm.scrollY, document.querySelector('.main'))
      if (vm.$empty(vm.$cookies.get('userSeq')) && vm.$empty(vm.$cookies.get('userName'))) {
        vm.$modal.show('phoneNumberModal')
        setTimeout(() => {
          vm.$refs.nameInput.focus()
        }, 100)
      } else {
        vm.inputCancel()
      }
      vm.$store.commit('setTitle', '스마트전단채팅')
      if (document.querySelector('html') !== null) {
        setTimeout(() => {
          document.querySelector('html').scrollTop = vm.scrollY
        }, 100)
      } else {
        setTimeout(() => {
          document.querySelector('html').scrollTop = vm.scrollY
        }, 1000)
      }
    })
  },
  // Record where you left
  beforeRouteLeave (to, from, next) {
    this.scrollY = document.querySelector('html').scrollTop
    console.log('Where to save the scroll bar when leaving', this.scrollY, to)
    this.$store.commit('setTitle', '')
    next()
  }
}
</script>

<style scoped lang="scss">
@import url('/css/chat.css');
.chat__wrap {
  // position: absolute;
  // left: 50%;
  width: 100%;
  height: 100%;
  // bottom: 2vh;
  // transform: translate(-50%, -2%);
  & .section {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: calc(100% - 60px);
    overflow-y: auto;
    background: #f7f7f7;
    .holding-display-date__container {
      width: 100%;
      height: 90px;
      display: flex;
      justify-content: center;
      text-align: center;
      position: sticky;
      position: -webkit-sticky;
      top: 0;
      z-index: 1;
      .holding-display-date__contents {
        width: auto;
        padding: 0 19px;
        line-height: 32px;
        height: 32px;
        background: #bababa;
        border-radius: 19px;
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        text-align: center;
        color: #ffffff;
      }
    }

    .chat-contents__wrap {
      width: 100%;
      padding-top: 25px;
      padding-bottom: 10px;
      .chat-contents {
        width: auto;
        height: auto;
        display: flex;

        &--questioner {
          justify-content: flex-end;
          padding-right: 20px;
          .inner__contents {
            position: relative;
            .name {
              height: 20px;
              line-height: 20px;
              text-align: right;
              color: hsla(0, 0%, 18%, 1);
            }
            .inner__text {
              position: relative;
              background: #ffffff;
              border-radius: 25px 0px 25px 25px;
              word-break: break-word;
              font-family: Noto Sans KR;
              font-style: normal;
              font-weight: normal;
              font-size: 14px;
              line-height: 20px;
              text-align: left;
              white-space: pre-line;
              &::before {
                content: ' ';
                position: absolute;
                width: 0;
                height: 0;
                border-top: 20px solid #ffffff;
                border-bottom: 0;
                border-right: 30px solid transparent;
                border-left: 30px solid transparent;
                right: -8px;
                top: 0;
              }
            }
            .time {
              text-align: right;
            }
          }
        }
        &--answerer {
          justify-content: flex-start;
          padding-left: 10px;
          padding-right: 10px;
          &.store {
            .user-info__contents {
              .profile-image {
                border-radius: 15px;
              }
            }
            .inner__contents {
              .inner__text {
                background: #fff8f8;
                color: #2d2d2d;
                border: 1px solid #ff86c0;
                .name {
                  color: hsla(0, 0%, 18%, 1);
                  font-weight: bold;
                }
                &::before {
                  z-index: 2;
                }
                &::after {
                  content: ' ';
                  position: absolute;
                  width: 0;
                  height: 0;
                  border-top: 24px solid #ff86c0;
                  border-bottom: 0;
                  border-right: 0px solid transparent;
                  border-left: 10px solid transparent;
                  left: -11px;
                  top: -1px;
                  z-index: 1;
                }
              }
            }
          }
          &.customer {
            .inner__contents {
              .inner__text {
                background: #f8f0ff;
                color: #2d2d2d;
                &::before {
                  border-top: 20px solid #f8f0ff;
                }
              }
            }
          }
          &.order {
            .inner__contents {
              .inner__text {
                background: hsla(119, 42%, 93%, 1);
                white-space: initial;
                &::before {
                  border-top: 20px solid hsla(119, 42%, 93%, 1);
                }
              }
            }
          }
          .inner__contents {
            position: relative;
            .name {
              height: 20px;
              line-height: 20px;
              text-align: left;
              color: hsla(0, 0%, 18%, 1);
            }
            .inner__text {
              position: relative;
              background: #ffffff;
              border-radius: 0px 25px 25px 25px;
              word-break: break-word;
              font-family: Noto Sans KR;
              font-style: normal;
              font-weight: normal;
              font-size: 14px;
              line-height: 20px;
              color: #636363;
              text-align: left;
              white-space: pre-line;
              &::before {
                content: ' ';
                position: absolute;
                width: 0;
                height: 0;
                border-bottom: 0;
                border-top: 24px solid #fff8f8;
                border-right: 64px solid transparent;
                border-left: 10px solid transparent;
                left: -9px;
                top: 0;
              }
            }
            .time {
              text-align: right;
            }
          }
        }
        .inner__contents {
          .time {
            color: gray;
          }
          .inner__text {
            padding: 20px;
            width: auto;
            height: auto;
            max-width: 300px;
            font-size: 14px;
          }
        }

        .user-info__contents {
          font-size: 35px;
          margin-top: -10px;
          margin-right: 10px;
          color: #2d2d2d;
          &.live {
            margin-top: -15px;
          }
          .profile-image {
            width: 50px;
            height: 50px;
            object-fit: cover;
            border-radius: 50%;
          }
        }
      }
    }
  }
}
.inner__image__src {
  width: 100%;
  object-fit: contain;
}

.info-button {
  position: fixed;
  bottom: 110px;
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  z-index: 3;
}

.button-image {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/chat.vue